import { Box, Typography } from '@mui/material';
import React from 'react';

type PermissionBlurProps = {
    allowed: boolean;
    children: React.ReactNode;
    label?: string;
    minHeight?: number | string;
    borderRadius?: number | string;
};

const PermissionBlur: React.FC<PermissionBlurProps> = ({
    allowed,
    children,
    label = 'دسترسی این بخش برای شما فعال نیست',
    minHeight,
    borderRadius = 2,
}) => {
    if (allowed) {
        return <>{children}</>;
    }

    return (
        <Box
            sx={{
                position: 'relative',
                overflow: 'hidden',
                minHeight,
                borderRadius,
            }}>
            <Box
                aria-hidden="true"
                sx={{
                    filter: 'blur(5px)',
                    opacity: 0.58,
                    pointerEvents: 'none',
                    userSelect: 'none',
                }}>
                {children}
            </Box>

            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    zIndex: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 2,
                    backgroundColor: 'rgba(15, 15, 20, 0.08)',
                    pointerEvents: 'none',
                }}>
                <Box
                    sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 1.5,
                        py: 0.9,
                        borderRadius: 2,
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: 'background.paper',
                        boxShadow: 1,
                    }}>
                    <i className="fa-light fa-lock" />
                    <Typography
                        sx={{
                            fontSize: 11.5,
                            fontWeight: 600,
                            color: 'text.secondary',
                        }}>
                        {label}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PermissionBlur;
